module.exports = __webpack_public_path__ + "img/articles-teaser-box.9c4b046e.svg";